import * as Yup from 'yup';
//utils
import {emailSchema, passwordSchema} from '@/utils/validation';

export type SignUpFormValues = {
	name: string;
	email: string;
	address: string;
	city: string;
	state: string;
	zip: string;
	taxIdNumber: number | null;
	password: string;
	confirmPassword: string;
	checkbox: boolean;
	image?: File[] | null;
};

export const initialValues: SignUpFormValues = {
	name: '',
	email: '',
	address: '',
	city: '',
	state: '',
	zip: '',
	taxIdNumber: null,
	password: '',
	confirmPassword: '',
	checkbox: false,
	image: null,
};

export const getValidationSchema = (isSocialSignup = false) => Yup.object().shape({
	name: Yup.string().required('Organization name is required').trim(),
	email: isSocialSignup ? Yup.string() : emailSchema,
	address: Yup.string().required('Organization address is required').trim(),
	city: Yup.string().required('City is required').trim(),
	state: Yup.string().required('State is required').trim(),
	zip: Yup.string().required('Zip is required').trim(),
	password: isSocialSignup ? Yup.string() : passwordSchema,
	confirmPassword: isSocialSignup
		? Yup.string()
		: Yup.string()
				.required('Passwords do not match')
				.test('passwords-match', 'Passwords do not match', function (value) {
					return this.parent.password === value;
				}),
	checkbox: Yup.boolean().oneOf([true], 'Terms of Use and the Privacy Policy mast be accept'),
});
